exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-to-cart-btn{margin:5px auto}@media (max-width: 767px){.variants-wrapper{padding-bottom:20px}}@media (max-width: 767px){.variants-wrapper .sizes{width:100%}}.variants-wrapper .size-guide{height:40px}@media (max-width: 767px){.variants-wrapper .size-guide{width:100%;margin-left:0}}.available-variation{position:relative;height:100%;padding-bottom:1px}.available-variation .available-items{max-height:calc(100vh - 85px);overflow:auto}.available-variation .close{position:absolute;right:0;top:0;height:40px;padding:0 8px}.available-variation .title-container{border-bottom:1px solid #eee}\n", ""]);

// exports
